import $ from 'jquery';
import {useState, createRoot} from '@wordpress/element';
import {Modal, Button, Flex, FlexItem, TextControl, ToggleControl} from '@wordpress/components';

const DEFAULTS = {
    enabled: 'no',
    verify_logged_in: 'yes',
    v3_site_key: '',
    v3_secret_key: '',
    v3_score: '0.5',
};

const toObject = (data) => data.reduce((acc, entry) => {
    acc[entry.key] = entry.value;
    return acc;
}, {});

const ReCaptchaModal = ({root, data, i18n}) => {
    const [open, setOpen] = useState(true);
    const [processing, setProcessing] = useState(false);
    const [value, setValue] = useState(() => toObject(data));

    const onClose = () => {
        setOpen(false);
        root.unmount();
    };

    const onChange = (key, newValue) => {
        setValue(prev => ({...prev, [key]: newValue}));
        $(document.body).triggerHandler('wc_ppcp_recaptcha_config_change', {key, value: newValue});
    };

    const onSave = () => {
        setProcessing(true);
        $(document.body).triggerHandler('wc_ppcp_app_settings_save');
    };

    const onReset = () => {
        const resetValues = data.reduce((acc, entry) => {
            acc[entry.key] = entry.default_value || DEFAULTS[entry.key] || '';
            return acc;
        }, {});
        setValue(resetValues);
        $(document.body).triggerHandler('wc_ppcp_recaptcha_config_reset');
    };

    if (!open) return null;

    return (
        <Modal
            title={i18n.recaptcha_title || 'reCAPTCHA Settings'}
            className={'wc-ppcp-recaptcha-modal'}
            onRequestClose={onClose}>
            <Flex direction={'column'} gap={4}>
                <FlexItem>
                    <ToggleControl
                        label={i18n.recaptcha_enabled || 'Enabled'}
                        checked={value.enabled === 'yes'}
                        onChange={(checked) => onChange('enabled', checked ? 'yes' : 'no')}
                    />
                </FlexItem>
                <FlexItem>
                    <TextControl
                        label={i18n.recaptcha_v3_site_key || 'Site Key (v3)'}
                        value={value.v3_site_key || ''}
                        onChange={(v) => onChange('v3_site_key', v)}
                    />
                </FlexItem>
                <FlexItem>
                    <TextControl
                        label={i18n.recaptcha_v3_secret_key || 'Secret Key (v3)'}
                        value={value.v3_secret_key || ''}
                        onChange={(v) => onChange('v3_secret_key', v)}
                        type={'password'}
                    />
                </FlexItem>
                <FlexItem>
                    <TextControl
                        label={i18n.recaptcha_v3_score || 'Minimum Score (v3)'}
                        help={i18n.recaptcha_v3_score_desc || 'Score threshold between 0.0 and 1.0. Requests below this score are blocked.'}
                        value={String(value.v3_score ?? '0.5')}
                        onChange={(v) => onChange('v3_score', v)}
                        type={'number'}
                        step={'0.1'}
                        min={'0'}
                        max={'1'}
                    />
                </FlexItem>
                <FlexItem>
                    <ToggleControl
                        label={i18n.recaptcha_verify_logged_in || 'Verify Logged In Users'}
                        checked={value.verify_logged_in === 'yes'}
                        onChange={(checked) => onChange('verify_logged_in', checked ? 'yes' : 'no')}
                        help={i18n.recaptcha_logged_in_desc}
                    />
                </FlexItem>
                <FlexItem>
                    <div className={'components-modal__footer'}>
                        <Flex direction={'row'} justify={'flex-end'}>
                            <Button variant={'secondary'} onClick={onClose}>{i18n.cancel}</Button>
                            <Button
                                variant={'primary'}
                                onClick={onSave}
                                isBusy={processing}
                                disabled={processing}>
                                {i18n.save}
                            </Button>
                        </Flex>
                    </div>
                </FlexItem>
            </Flex>
        </Modal>
    );
};

ReCaptchaModal.render = (el, {value, i18n}) => {
    if (createRoot) {
        const root = createRoot(el);
        root.render(<ReCaptchaModal root={root} data={value} i18n={i18n}/>);
    }
};

export default ReCaptchaModal;